import React from 'react';
import { useWebContents } from '../../hooks/useWebContents';
import Section from '../../customized/HeadingContentPair';
import { useImages } from '../../hooks/useImages';

const GUIDS = {
  aboutUs: '5a8b0a4d-1f6d-4dde-ab24-f286af9dd07c',
  ourVision: '36604c10-e87e-4ae8-b319-c0e72e6ed7ae',
  winterCompost: 'fcc242a7-fa2b-4e39-810a-d9663fafac53',
  gardenCompost: '94a0d473-defa-45ad-9823-94f2994acd64'
};

const AboutUs: React.FC = () => {
  const contents = useWebContents(GUIDS,  'Home');

  const aboutUsImage = useImages(GUIDS.aboutUs)?.image;
  const ourVisionImage = useImages(GUIDS.ourVision)?.image;
  const winterCompostImage = useImages(GUIDS.winterCompost)?.image;
  const gardenCompostImage = useImages(GUIDS.gardenCompost)?.image;

  return (
    <section className="py-12 px-4 flex flex-col items-center">
      <div className="w-full max-w-7xl grid grid-cols-1 md:grid-cols-3 gap-4 items-stretch ">
        <Section
          imageSrc={aboutUsImage}
          imageAlt="Family Picture"
          className="h-full"
        />

        <Section
          imageSrc={winterCompostImage}
          imageAlt="Winter Compost"
          className="h-full"
        />

        <Section
          imageSrc={ourVisionImage}
          imageAlt="Compost Buckets"
          className="h-full"
        />

        <Section
          heading={contents.aboutUs.heading}
          content={contents.aboutUs.content}
          className="h-full"
        />

        <Section
          imageSrc={gardenCompostImage}
          imageAlt="Garden Compost"
          className="h-full"
        />

        <Section
          heading={contents.ourVision.heading}
          content={contents.ourVision.content}
          className="h-full"
        />
      </div>
    </section>
  )
};

export default AboutUs;